const V1SUB_URL = "/api/v1";

export const SUPER_ADMIN_LOGIN_URL = V1SUB_URL + "/request-admin-otp";
export const REFRESH_TOKEN_URL = V1SUB_URL + "/refresh-token";
export const ADD_COUNTRY_ADMIN = V1SUB_URL + "/super-admin/country-admin/assign";
export const UPDATE_COUNTRY_ADMIN = V1SUB_URL + "/super-admin/country-admin/update";
export const DELETE_COUNTRY_ADMIN = V1SUB_URL + "/super-admin/country-admin/delete";
export const GET_COUNTRY_ADMIN = V1SUB_URL + "/super-admin/country-admin/get-list";
export const ADD_LAUNGUGE = V1SUB_URL + "/country-admin/language/add";
export const GET_LAUNGUGE = V1SUB_URL + "/country-admin/language/get-all";
export const GET_COUNTRY = V1SUB_URL + "/super-admin/country";
export const UPDATE_COUNTRY_EMAIL = V1SUB_URL + "/super-admin/country/email/update";
export const GET_DASHBOARD = V1SUB_URL + "/country-admin/dashboard";
export const ADD_STATIC_STRINGS = V1SUB_URL + "/country-admin/static-string/add/single";
export const ADD_STATIC_STRINGS_JSON = V1SUB_URL + "/country-admin/static-string/add/json";
export const GET_STATIC_STRINGS = V1SUB_URL + "/country-admin/static-string";
export const UPDATE_STATIC_STRINGS = V1SUB_URL + "/country-admin/static-string/update";
export const DELETE_STATIC_STRINGS = V1SUB_URL + "/country-admin/static-string";
export const ADD_STATIC_CONTENT = V1SUB_URL + "/country-admin/static-content/add";
export const GET_STATIC_CONTENT = V1SUB_URL + "/country-admin/static-content/get";
export const UPDATE_STATIC_CONTENT = V1SUB_URL + "/country-admin/static-content/update";
export const ADD_QUE = V1SUB_URL + "/country-admin/healthcare-que/add";
export const GET_QUE = V1SUB_URL + "/country-admin/healthcare-que/get";
export const UPDATE_QUE = V1SUB_URL + "/country-admin/healthcare-que/update";
export const DELETE_QUE = V1SUB_URL + "/country-admin/healthcare-que/delete";
export const ADD_HCP_ASSIGN = V1SUB_URL + "/country-admin/hcp/assign";
export const GET_HCP_ASSIGN = V1SUB_URL + "/country-admin/hcp/list";
export const ADD_HOSPITAL = V1SUB_URL + "/country-admin/hospital/add";
export const GET_HOSPITAL = V1SUB_URL + "/country-admin/hospital/list";
export const UPDATE_HOSPITAL = V1SUB_URL + "/country-admin/hospital/update";
export const VIEW_HOSPITAL = V1SUB_URL + "/country-admin/hospital/single";
export const UPDATE_HCP_ASSIGN = V1SUB_URL + "/country-admin/hcp/update";
export const SUPER_ADMIN_VERIFY_OTP_URL = V1SUB_URL + "/verify-admin-otp";
export const SUPER_ADMIN_RESEND_OTP_URL = V1SUB_URL + "/resend-admin-otp";
export const GET_VERSION_URL = V1SUB_URL + "/super-admin/version/latest";
export const UPDATE_VERSION_URL = V1SUB_URL + "/super-admin/version/update";
export const GET_COUNTRY_LIST = V1SUB_URL + "/super-admin/country/server-list";
export const DELETE_HCP = V1SUB_URL + "/country-admin/hcp/delete";
export const GET_REQUESTS = V1SUB_URL + "/country-admin/hcp/request";
export const UPDATE_REQUEST_STATUS = V1SUB_URL + "/country-admin/hcp/request/status";